import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ApplicationDetails from 'widgets/ApplicationDetails';
import arrayContains from 'utils/arrayUtils';
import Preloader from 'components/Preloader';

import { EXTERNAL_PRODUCTS } from 'constants/constants';
import { ApplicationDetailsManager } from 'datasource/useApplicationDetails/ApplicationDetailsManager';
import { useGetInvestmentApp } from 'hooks/rest/useGetInvestmentApp';
import { useClientLayout } from 'pages/ClientOverview/hooks/useClientLayout';
import { isNotObject } from 'utils';

const ApplicationDetailsPage = () => {
    const { i18n: { language } } = useTranslation();
    const { containerId, applicationId } = useParams();

    useClientLayout();

    const {
        data: investmentAppsData,
        isLoading: isInvestmentApplicationsLoading,
        refetch: getInvestmentApplications,
    } = useGetInvestmentApp({
        containerOrApplicationId: containerId || applicationId,
        language,
        isContainer: !!containerId,
        isEnabled: !!(containerId || applicationId) && !!language,
    });

    const is3aVB = useMemo(() => {
        const externalId = investmentAppsData?.[0]?.productExternalId;

        return arrayContains([EXTERNAL_PRODUCTS.aaa, EXTERNAL_PRODUCTS.aaap, EXTERNAL_PRODUCTS.fz, EXTERNAL_PRODUCTS.fzp], externalId);
    }, [investmentAppsData?.[0]?.productExternalId]);

    const boolean3aVB = useMemo(() => is3aVB && isNotObject(is3aVB), [is3aVB]);

    return (
        <Preloader isLoading={isInvestmentApplicationsLoading}>
            <ApplicationDetailsManager
                investmentAppsData={investmentAppsData || []}
                isInvestmentApplicationsLoading={isInvestmentApplicationsLoading}
                getInvestmentApplications={getInvestmentApplications}
                is3aVB={boolean3aVB as boolean}
            >
                <div className="container">
                    <div className="fi-verticals">
                        <ApplicationDetails is3aVB={boolean3aVB} />
                    </div>
                </div>
            </ApplicationDetailsManager>
        </Preloader>
    );
};

export default ApplicationDetailsPage;
